import { render, staticRenderFns } from "./TourListHeader.vue?vue&type=template&id=0252774d&scoped=true&"
import script from "./TourListHeader.vue?vue&type=script&lang=js&"
export * from "./TourListHeader.vue?vue&type=script&lang=js&"
import style0 from "./TourListHeader.vue?vue&type=style&index=0&id=0252774d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0252774d",
  null
  
)

export default component.exports